module.exports = __webpack_public_path__ + "static/img/teaching.6607b37c.png";